import { blueGrey, green, lime, purple } from '@mui/material/colors';

import MUIFonts from './MUIFonts';

import lightTheme from '../components/style/lightTheme';

const MuiChip = {
  styleOverrides: {
    root: {
      borderRadius: '100px',
      textTransform: 'uppercase' as const,
      '&.MuiChip-filled.MuiChip-colorDefault': {
        backgroundColor: lightTheme.alertInfoFill,
        color: lightTheme.alertInfoContent,
        borderColor: lightTheme.alertInfoFill,
      },
      ...MUIFonts.chipLabel,
      '&.MuiChip-filled.MuiChip-colorError': {
        backgroundColor: lightTheme.alertErrorFill,
        borderColor: lightTheme.alertErrorFill,
        color: lightTheme.alertErrorContent,
      },
      '&.MuiChip-filled.MuiChip-colorWarning': {
        backgroundColor: lightTheme.alertWarningFill,
        borderColor: lightTheme.alertWarningFill,
        color: lightTheme.alertWarningContent,
      },
      '&.MuiChip-filled.MuiChip-colorInfo': {
        backgroundColor: lightTheme.alertInfoFill,
        borderColor: lightTheme.alertInfoFill,
        color: lightTheme.alertInfoContent,
      },
      '&.MuiChip-filled.MuiChip-colorSuccess': {
        backgroundColor: lightTheme.alertSuccessFill,
        borderColor: lightTheme.alertSuccessFill,
        color: lightTheme.alertSuccessContent,
      },

      '&.MuiChip-colorSuccessDark': {
        backgroundColor: lightTheme.primaryBgSubtle,
        borderColor: lightTheme.primaryBgSubtle,
        color: lightTheme.successDark,
      },

      '&.MuiChip-subtle.MuiChip-colorError': {
        backgroundColor: lightTheme.chipErrorFilledSubtle,
        color: lightTheme.chipOnErrorFilledSubtle,
      },
      '&.MuiChip-subtle.MuiChip-colorInfo': {
        backgroundColor: lightTheme.chipInfoFilledSubtle,
        color: lightTheme.chipOnInfoFilledSubtle,
      },
      '&.MuiChip-subtle.MuiChip-colorSuccess': {
        backgroundColor: lightTheme.chipSuccessFilledSubtle,
        borderColor: lightTheme.chipSuccessFilledSubtle,
        color: lightTheme.chipOnSuccessFilledSubtle,
      },
      '&.MuiChip-serviceowner': {
        backgroundColor: blueGrey[800],
        borderColor: blueGrey[800],
        color: lightTheme.sysNeutral0,
      },
      '&.MuiChip-owner': {
        backgroundColor: lightTheme.sysPrimaryLight,
        borderColor: lightTheme.sysPrimaryLight,
        color: lightTheme.alertSuccessContent,
      },
      '&.MuiChip-admin': {
        backgroundColor: green[200],
        borderColor: green[200],
        color: lightTheme.alertSuccessContent,
      },
      '&.MuiChip-auditor': {
        backgroundColor: lime[300],
        borderColor: lime[300],
        color: lightTheme.alertSuccessContent,
      },
      '&.MuiChip-reseller': {
        backgroundColor: lightTheme.secondaryBgSubtle,
        borderColor: lightTheme.secondaryBgSubtle,
        color: lightTheme.secondaryBtnPressed,
      },
      '&.MuiChip-distributor': {
        backgroundColor: purple[100],
        borderColor: purple[100],
        color: purple[900],
      },
      '&.MuiChip-boolean': {
        backgroundColor: 'transparent',
        border: 'none',
        color: 'unset',
      },
      '&.MuiChip-boolean.MuiChip-colorError': {
        color: lightTheme.dangerIcon,
      },
      '&.MuiChip-boolean.MuiChip-colorSuccess': {
        color: lightTheme.successIcon,
      },
      '&.MuiChip-boolean.MuiChip-colorDisabled': {
        color: lightTheme.icon,
      },
    },
  },
};

export default MuiChip;
